<template>
  <v-card>
    <v-layout>
      <v-flex sm5>
        <v-img :src="post.main_image" height="200" min-width="200"/>
      </v-flex>
      <v-flex sm7>
        <v-card-title primary-title>
          <div>
            <div class="caption-security grey-security">{{ post.published_at }}</div>
            <div :title="post.full_title" class="text-24-security blue-security font-weight-bold line-heigth-security">{{ post.title }}</div>
            <span class="grey--text">{{ post.extract }}</span>
          </div>
        </v-card-title>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
export default {
  props: {
    post: { type: Object, required: true }
  }
}
</script>
<style>
  
</style>